import { ValidationWithSubErrors } from 'types/common';

type GroupedColumnError = {
    column: string;
    missingRows: number[];
    invalidFormatRows: number[];
};

// Extracts tow number and column name
const parseField = (field: string): { column: string; row: number } | null => {
    const match = field.match(/^row\[(\d+)\]\.(.+)$/);
    if (!match) return null;
    return { row: parseInt(match[1]), column: match[2] };
};

// Note: For now we aggreed that the grouping will happen on the FE, but in the future when we need to allow fixing the errors,
// it would be better that we receive the data grouped from the BE
export const groupErrorsByColumn = (subErrors: ValidationWithSubErrors['subErrors']): GroupedColumnError[] => {
    const map = new Map<string, GroupedColumnError>();

    for (const err of subErrors) {
        const parsed = parseField(err.field);
        if (!parsed) continue;

        const { column, row } = parsed;
        if (!map.has(column)) {
            map.set(column, { column, missingRows: [], invalidFormatRows: [] });
        }

        const group = map.get(column)!;
        if (/must not be blank/i.test(err.message)) {
            group.missingRows.push(row);
        } else {
            group.invalidFormatRows.push(row);
        }
    }

    return Array.from(map.values());
};
